import { c as _c } from "react/compiler-runtime";
import DnsSettingsModal from 'modules/profile/mailing-settings/components/dns-settings-modal';
import { MailingSettingsDomainInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import React, { useState } from 'react';
import { EyeIcon } from '@systemeio/ui/icons';
function DnsSettingsModalWithButton(t0) {
  const $ = _c(6);
  const {
    domainData
  } = t0;
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpened(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onClose = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="cursor-pointer lg:ml-8"><EyeIcon onClick={() => setOpened(true)} className="hover:fill-brand-primary" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== domainData.dnsSettings || $[3] !== domainData.id || $[4] !== opened) {
    t3 = <>{t2}<DnsSettingsModal domainId={domainData.id} dnsSettings={domainData.dnsSettings} opened={opened} onClose={onClose} /></>;
    $[2] = domainData.dnsSettings;
    $[3] = domainData.id;
    $[4] = opened;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default DnsSettingsModalWithButton;